<template>
    <div>
        <div
            class="flex flex-row justify-between items-center p-2 rounded shadow-inner border border-grey-light bg-white inline-block w-full"
        >
            <input
                type="search"
                v-model="searchTerm"
                class="w-full max-w-full flex-grow-1 rounded-lg h-10 font-bold outline-none"
                @keydown.down="adjustIndex(1)"
                @keydown.up="adjustIndex(-1)"
                @keyup.enter="selectResult"
                @focus.once="getData"
                :placeholder="placeholder"
            />
            <div
                v-if="loading"
                class="flex items-center flex-shrink-0 justify-center h-10 w-10 content"
            >
                <div class="is-loading dark-spinner large-spinner">
                    <span></span>
                </div>
            </div>
            <div
                v-if="searchTerm"
                class="flex items-center justify-center mr-4 w-auto content text-grey text-sm font-bold text-right whitespace-no-wrap"
            >{{ filteredEntriesBySearchTerm.length }} filtered results</div>
            <div
                v-else-if="entries.length"
                class="flex items-center justify-center mr-4 w-auto content text-grey text-sm font-bold text-right whitespace-no-wrap"
            >{{ entries.length }} available entries to search from</div>
        </div>
        <div
            v-if="filteredEntriesBySearchTerm.length > 0"
            class="relative overflow-y-scroll"
            style="max-height: 250px;"
        >
            <a
                class="p-4 border-t no-underline cursor-pointer flex justify-between items-start text-base hover:bg-grey-lighter hover:text-black"
                :class="selectIndex == 0 ? 
						'bg-grey-lighter text-black' : 
						'bg-white text-grey-dark '"
                :href="allResultsEndpoint"
            >See all results...</a>
            <a
                v-for="(entry, index) in filteredEntriesBySearchTerm"
                :key="entry.id"
                :href="entry.url"
                class="block p-4 border-t no-underline cursor-pointer text-base"
                :class="index == selectIndex - 1 ? 
							'bg-grey-lighter hover:bg-grey-light text-black hover:underline' : 
							'bg-white hover:bg-grey-lighter text-grey-dark hover:text-grey-darker'"
            >
                {{ entry.title }}
                <span class="opacity-50 font-bold ml-4">{{ entry.section }}</span>
            </a>
        </div>
    </div>
</template>

<script>
const debounce = require("lodash.debounce");
import formatDistance from "date-fns/formatDistance";
export default {
    props: {
        endpoint: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            searchTerm: "",
            entries: [],
            selectIndex: 0,
            loading: false
        };
    },
    methods: {
        async getData() {
            this.loading = true;
            let response = await axios.get(this.endpoint);
            this.entries = response.data.data;
            this.loading = false;
        },
        adjustIndex(val) {
            if (val == -1 && this.selectIndex == 0) {
                return;
            }
            if (val == 1 && this.selectIndex == this.entries.length + 1) {
                return;
            }
            this.selectIndex += val;
        },
        selectResult() {
            let url = "";
            if (this.selectIndex == 0) {
                url = this.allResultsEndpoint;
            } else {
                let result = this.entries[this.selectIndex - 1];
                url = result.url;
            }
            window.location = url;
        }
    },
    mounted() {
        // this.getData();
    },
    watch: {
        searchTerm: debounce(newVal => {
            window.ga("send", "pageview", `/search?q=${newVal}`);
        }, 1000)
    },
    computed: {
        filteredEntriesBySearchTerm() {
            if (this.entries.length > 0 && this.searchTerm.length > 1) {
                return this.entries
                    .filter(entry => {
                        return entry.title
                            .toUpperCase()
                            .concat(entry.description.toUpperCase())
                            .includes(this.searchTerm.toUpperCase());
                    })
                    .map(entry => {
                        entry.formattedUpdatedDate = formatDistance(
                            new Date(),
                            new Date(entry.updated_at)
                        );
                        entry.formattedCreatedDate = formatDistance(
                            new Date(),
                            new Date(entry.created_at)
                        );
                        return entry;
                    })
                    .sort((a, b) => {
                        return a.created_at < b.created_at
                            ? 1
                            : b.created_at < a.created_at
                            ? -1
                            : 0;
                    });
            } else {
                return [];
            }
        },
        allResultsEndpoint() {
            if (this.endpoint == "/knowledge-base-entries.json") {
                return `/search?s=kbnews&q=${this.searchTerm}`;
            }
            if (this.endpoint == "/page-entries.json") {
                return `/search?s=pages&q=${this.searchTerm}`;
            }

            return `/search?s=all&q=${this.searchTerm}`;
        }
    }
};
</script>

<style  lang="less" scoped>
.is-loading {
    span::after {
        top: 0;
        right: 0;
    }
}
</style>